import { createAsyncThunk, createSlice, isAsyncThunkAction,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { ExpenseCategoryStateClass } from "./interfaces/expenseCategoryStateClass";
import { sortData } from "../../../common/timeLiveFunction";


const initialState: ExpenseCategoryStateClass = {
    isLoading: false,
    ExpenseCategoryList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'AccountExpenseName',
    search: '',
    pageNo: 1,
    pageSize: 10
};

interface IThunkApi {
    state: {
        expenseCategory: ExpenseCategoryStateClass
    }
};

export const getAccountExpenseCategoriesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "ExpenseCategory/v2/getAccountExpenseCategories",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Expenses", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }

    )
export const getAccountExpenseCategoryByExpenseCategoryIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExpenseCategory/v2/getAccountExpenseCategoryByExpenseCategoryId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Expenses/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const addAccountExpenseCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'ExpenseCategory/v2/addAccountExpenseCategory',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Expenses/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountExpenseCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'ExpenseCategory/v2/updateAccountExpenseCategory',
        async (arg, thunkApi) => {
            const { AccountExpenseId, ExpenseType, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Expenses/' + AccountExpenseId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountExpenseCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExpenseCategory/v2/deleteAccountExpenseCategory",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Expenses/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const DeleteSelectedAccountExpenseCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ExpenseCategory/v2/DeleteSelectedAccountExpenseCategory",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Expenses/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const expenseCategorySlice = createSlice({
    name: "expenseCategory",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.ExpenseCategoryList.findIndex((item) => item.AccountExpenseId == action.payload);
            const newArray = [...state.ExpenseCategoryList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.ExpenseCategoryList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.ExpenseCategoryList.findIndex((item) => item.AccountExpenseId == action.payload);
            const newArray = [...state.ExpenseCategoryList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.ExpenseCategoryList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.ExpenseCategoryList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.ExpenseCategoryList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.ExpenseCategoryList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.ExpenseCategoryList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.ExpenseCategoryList;
            state.ExpenseCategoryList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountExpenseCategoriesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountExpenseCategoriesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.ExpenseCategoryList = [];
                } else {
                    state.ExpenseCategoryList = payload.Data;
                    state.ExpenseCategoryList.map((item: any) => {
                        item.isSelected = 0
                    });
                }

                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountExpenseCategoriesAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getAccountExpenseCategoryByExpenseCategoryIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountExpenseCategoryByExpenseCategoryIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                
                state.isLoading = false;
            })
            .addCase(getAccountExpenseCategoryByExpenseCategoryIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountExpenseCategoryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountExpenseCategoryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountExpenseCategoryAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountExpenseCategoryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountExpenseCategoryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountExpenseCategoryAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountExpenseCategoryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountExpenseCategoryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountExpenseCategoryAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(DeleteSelectedAccountExpenseCategoryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountExpenseCategoryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountExpenseCategoryAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
});

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting } = expenseCategorySlice.actions
export const expenseCategoryState = (state: RootState) => state.expenseCategory
export default expenseCategorySlice.reducer


